import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", function () {
  casesSlider();
});

// Cases Slider
function casesSlider() {
  let sliders = document.querySelectorAll(".ticker__wrapper");  
  sliders.forEach((sliderElement) => {
    let slider = new Glide(sliderElement, {
      type: 'carousel',
      autoplay: 2000,
      hoverpause: false,
      perView: 7,
      animationDuration: 9000,
      animationTimingFunc: 'linear'
    });

    slider.mount();
  });
}